import SubPageContainer from '@/components/SubPageContainer'

import MyCompanyHome from '@/pages/MyCompanyHome'

import MyCompany from '@/pages/MyCompany'
import MyCompanyEdit from '@/pages/MyCompanyEdit'

import MyCompanyGroups from '@/pages/MyCompanyGroups'
import MyCompanyGroupsNew from '@/pages/MyCompanyGroupsNew'
import MyCompanyGroupsEdit from '@/pages/MyCompanyGroupsEdit'

import MyCompanyArticles from '@/pages/MyCompanyArticles'
import MyCompanyArticlesNew from '@/pages/MyCompanyArticlesNew'
import MyCompanyArticlesEdit from '@/pages/MyCompanyArticlesEdit'

import MyCompanyCategories from '@/pages/MyCompanyCategories'
import MyCompanyCategoriesNew from '@/pages/MyCompanyCategoriesNew'
import MyCompanyCategoriesEdit from '@/pages/MyCompanyCategoriesEdit'

import MyCompanyLevels from '@/pages/MyCompanyLevels'
import MyCompanyLevelsNew from '@/pages/MyCompanyLevelsNew'
import MyCompanyLevelsEdit from '@/pages/MyCompanyLevelsEdit'

import MyCompanyUsers from '@/pages/MyCompanyUsers'
import MyCompanyUsersNew from '@/pages/MyCompanyUsersNew'
import MyCompanyUsersEdit from '@/pages/MyCompanyUsersEdit'
import MyCompanyUsersResetPass from '@/pages/MyCompanyUsersResetPass'

import MyCompanyUserTypes from '@/pages/MyCompanyUserTypes'
import MyCompanyUserTypesNew from '@/pages/MyCompanyUserTypesNew'
import MyCompanyUserTypesEdit from '@/pages/MyCompanyUserTypesEdit'

import MyCompanyClients from '@/pages/MyCompanyClients'
import MyCompanyClientsNew from '@/pages/MyCompanyClientsNew'
import MyCompanyClientsEdit from '@/pages/MyCompanyClientsEdit'

import MyCompanyPaymentTypes from '@/pages/MyCompanyPaymentTypes'
import MyCompanyPaymentTypesNew from '@/pages/MyCompanyPaymentTypesNew'
import MyCompanyPaymentTypesEdit from '@/pages/MyCompanyPaymentTypesEdit'

import MyCompanyTaxTypes from '@/pages/MyCompanyTaxTypes'
import MyCompanyTaxTypesNew from '@/pages/MyCompanyTaxTypesNew'
import MyCompanyTaxTypesEdit from '@/pages/MyCompanyTaxTypesEdit'

import MyCompanyTaxLevels from '@/pages/MyCompanyTaxLevels'
import MyCompanyTaxLevelsNew from '@/pages/MyCompanyTaxLevelsNew'
import MyCompanyTaxLevelsEdit from '@/pages/MyCompanyTaxLevelsEdit'

import MyCompanyLocations from '@/pages/MyCompanyLocations'
import MyCompanyLocationsNew from '@/pages/MyCompanyLocationsNew'
import MyCompanyLocationsEdit from '@/pages/MyCompanyLocationsEdit'

import MyCompanyPrintersLocations from '@/pages/MyCompanyPrintersLocations'
import MyCompanyPrintersLocationsNew from '@/pages/MyCompanyPrintersLocationsNew'
import MyCompanyPrintersLocationsEdit from '@/pages/MyCompanyPrintersLocationsEdit'

import MyCompanyComments from '@/pages/MyCompanyComments'
import MyCompanyCommentsNew from '@/pages/MyCompanyCommentsNew'
import MyCompanyCommentsEdit from '@/pages/MyCompanyCommentsEdit'

import MyCompanyBusinessUnitPricing from "@/pages/MyCompanyBusinessUnitPricing"
import MyCompanyBusinessUnitPricingNew from "@/pages/MyCompanyBusinessUnitPricingNew"
import MyCompanyBusinessUnitPricingEdit from "@/pages/MyCompanyBusinessUnitPricingEdit"

import MyCompanyTables from '@/pages/MyCompanyTables'
import MyCompanyTablesNew from '@/pages/MyCompanyTablesNew'
import MyCompanyTablesEdit from '@/pages/MyCompanyTablesEdit'

import MyCompanyAcceptanceForms from '@/pages/MyCompanyAcceptanceForms'
import MyCompanyAcceptanceFormsNew from '@/pages/MyCompanyAcceptanceFormsNew'
import MyCompanyAcceptanceFormsEdit from '@/pages/MyCompanyAcceptanceFormsEdit'
import MyCompanyAcceptanceFormsPreview from '@/pages/MyCompanyAcceptanceFormsPreview'
import MyCompanyGlobalInvoicesPreview from '@/pages/MyCompanyGlobalInvoicesPreview'
import MyCompanyAcceptanceFormPreview from '@/pages/MyCompanyAcceptanceFormPreview'

import MyCompanyWriteoffForms from '@/pages/MyCompanyWriteoffForms'
import MyCompanyWriteoffFormsNew from '@/pages/MyCompanyWriteoffFormsNew'
import MyCompanyWriteoffFormsEdit from '@/pages/MyCompanyWriteoffFormsEdit'
import MyCompanyWriteoffFormsPreview from '@/pages/MyCompanyWriteoffFormsPreview'
import MyCompanyWriteoffFormPreview from '@/pages/MyCompanyWriteoffFormPreview'

import MyCompanyInventoryForms from '@/pages/MyCompanyInventoryForms'
import MyCompanyInventoryFormsNew from '@/pages/MyCompanyInventoryFormsNew'
import MyCompanyInventoryFormsEdit from '@/pages/MyCompanyInventoryFormsEdit'
import MyCompanyInventoryFormPreview from '@/pages/MyCompanyInventoryFormPreview'

import MyCompanyCurrentStock from '@/pages/MyCompanyCurrentStock'
import MyCompanyCurrentStockPreview from '@/pages/MyCompanyCurrentStockPreview'
import MyCompanyArticleCardPreview from '@/pages/MyCompanyArticleCardPreview'

import MyCompanyElectronicDevicesList from '@/pages/MyCompanyElectronicDevicesList'
import MyCompanyMaterialDiaryList from '@/pages/MyCompanyMaterialDiaryList'

import MyCompanyReportsUsers from '@/pages/MyCompanyReportsUsers'
import MyCompanyReportsDaily from '@/pages/MyCompanyReportsDaily'
import MyCompanyReportsArticles from '@/pages/MyCompanyReportsArticles'
import MyCompanyReportsInvoices from '@/pages/MyCompanyReportsInvoices'
// import MyCompanyReportsClosedTables from '@/pages/MyCompanyReportsClosedTables'
import MyCompanyReportsPrint from '@/pages/MyCompanyReportsPrint'
import MyCompanyReportsDailyPreview from '@/pages/MyCompanyReportsDailyPreview'

import MyCompanyInvoiceHistory from '@/pages/MyCompanyInvoiceHistory'
import MyCompanyOpenTables from '@/pages/MyCompanyOpenTables'
import MyCompanyType1OpenTables from '@/pages/MyCompanyType1OpenTables'
import MyCompanyInvoicePreview from '@/pages/MyCompanyInvoicePreview'
import MyCompanyMaterialDiaryPreview from '@/pages/MyCompanyMaterialDiaryPreview'
import MyCompanyArhivPreview from '@/pages/MyCompanyArhivPreview'

import MyCompanyControlTape from '@/pages/MyCompanyControlTape'
import MyCompanyControlTapeDownload from '@/pages/MyCompanyControlTapeDownload'

export default [
  {
    path: '/',
    name: 'MyCompanyHome',
    component: MyCompanyHome,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/groups',
    name: 'MyCompanyGroups',
    component: MyCompanyGroups
  },
  {
    path: '/groups/new',
    name: 'MyCompanyGroupsNew',
    component: MyCompanyGroupsNew
  },
  {
    path: '/groups/:id/edit',
    name: 'MyCompanyGroupsEdit',
    component: MyCompanyGroupsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/articles',
    name: 'MyCompanyArticles',
    component: MyCompanyArticles
  },
  {
    path: '/articles/new',
    name: 'MyCompanyArticlesNew',
    component: MyCompanyArticlesNew,
    props: true
  },
  {
    path: '/articles/:id/edit',
    name: 'MyCompanyArticlesEdit',
    component: MyCompanyArticlesEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/categories',
    name: 'MyCompanyCategories',
    component: MyCompanyCategories
  },
  {
    path: '/categories/new',
    name: 'MyCompanyCategoriesNew',
    component: MyCompanyCategoriesNew
  },
  {
    path: '/categories/:id/edit',
    name: 'MyCompanyCategoriesEdit',
    component: MyCompanyCategoriesEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/levels',
    name: 'MyCompanyLevels',
    component: MyCompanyLevels
  },
  {
    path: '/levels/new',
    name: 'MyCompanyLevelsNew',
    component: MyCompanyLevelsNew
  },
  {
    path: '/levels/:id/edit',
    name: 'MyCompanyLevelsEdit',
    component: MyCompanyLevelsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/users',
    name: 'MyCompanyUsers',
    component: MyCompanyUsers
  },
  {
    path: '/users/new',
    name: 'MyCompanyUsersNew',
    component: MyCompanyUsersNew
  },
  {
    path: '/users/:id/edit',
    name: 'MyCompanyUsersEdit',
    component: MyCompanyUsersEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/users/:id/reset-pass',
    name: 'MyCompanyUsersResetPass',
    component: MyCompanyUsersResetPass,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/user-types',
    name: 'MyCompanyUserTypes',
    component: MyCompanyUserTypes
  },
  {
    path: '/user-types/new',
    name: 'MyCompanyUserTypesNew',
    component: MyCompanyUserTypesNew
  },
  {
    path: '/user-types/:id/edit',
    name: 'MyCompanyUserTypesEdit',
    component: MyCompanyUserTypesEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/company-clients',
    name: 'MyCompanyClients',
    component: MyCompanyClients
  },
  {
    path: '/company-clients/new',
    name: 'MyCompanyClientsNew',
    component: MyCompanyClientsNew
  },
  {
    path: '/company-clients/:id/edit',
    name: 'MyCompanyClientsEdit',
    component: MyCompanyClientsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/payment-types',
    name: 'MyCompanyPaymentTypes',
    component: MyCompanyPaymentTypes
  },
  {
    path: '/payment-types/new',
    name: 'MyCompanyPaymentTypesNew',
    component: MyCompanyPaymentTypesNew
  },
  {
    path: '/payment-types/:id/edit',
    name: 'MyCompanyPaymentTypesEdit',
    component: MyCompanyPaymentTypesEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/tax-types',
    name: 'MyCompanyTaxTypes',
    component: MyCompanyTaxTypes
  },
  {
    path: '/tax-types/new',
    name: 'MyCompanyTaxTypesNew',
    component: MyCompanyTaxTypesNew
  },
  {
    path: '/tax-types/:id/edit',
    name: 'MyCompanyTaxTypesEdit',
    component: MyCompanyTaxTypesEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/tax-levels',
    name: 'MyCompanyTaxLevels',
    component: MyCompanyTaxLevels
  },
  {
    path: '/tax-levels/new',
    name: 'MyCompanyTaxLevelsNew',
    component: MyCompanyTaxLevelsNew
  },
  {
    path: '/tax-levels/:id/edit',
    name: 'MyCompanyTaxLevelsEdit',
    component: MyCompanyTaxLevelsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/my-company',
    component: SubPageContainer,
    redirect: {
      name: 'MyCompany'
    },
    children: [
      {
        path: '',
        name: 'MyCompany',
        component: MyCompany
      },
      {
        path: 'edit',
        name: 'MyCompanyEdit',
        component: MyCompanyEdit
      }
    ]
  },
  {
    path: '/locations',
    name: 'MyCompanyLocations',
    component: MyCompanyLocations
  },
  {
    path: '/locations/new',
    name: 'MyCompanyLocationsNew',
    component: MyCompanyLocationsNew,
    props: true
  },
  {
    path: '/locations/:id/edit',
    name: 'MyCompanyLocationsEdit',
    component: MyCompanyLocationsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/pricing',
    name: 'MyCompanyBusinessUnitPricing',
    component: MyCompanyBusinessUnitPricing
  },
  {
    path: 'pricing-new',
    name: 'MyCompanyBusinessUnitPricingNew',
    component: MyCompanyBusinessUnitPricingNew
  },
  {
    path: '/pricing/:id/edit',
    name: 'MyCompanyBusinessUnitPricingEdit',
    component: MyCompanyBusinessUnitPricingEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/comments',
    name: 'MyCompanyComments',
    component: MyCompanyComments
  },
  {
    path: '/comments/new',
    name: 'MyCompanyCommentsNew',
    component: MyCompanyCommentsNew
  },
  {
    path: '/comments/:id/edit',
    name: 'MyCompanyCommentsEdit',
    component: MyCompanyCommentsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/printerlocations',
    name: 'MyCompanyPrintersLocations',
    component: MyCompanyPrintersLocations
  },
  {
    path: '/printerlocations/new',
    name: 'MyCompanyPrintersLocationsNew',
    component: MyCompanyPrintersLocationsNew
  },
  {
    path: '/printerslocations/:id/edit',
    name: 'MyCompanyPrintersLocationsEdit',
    component: MyCompanyPrintersLocationsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/tables',
    name: 'MyCompanyTables',
    component: MyCompanyTables
  },
  {
    path: '/tables/new',
    name: 'MyCompanyTablesNew',
    component: MyCompanyTablesNew,
    props: true
  },
  {
    path: '/tables/:id/edit',
    name: 'MyCompanyTablesEdit',
    component: MyCompanyTablesEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/acceptance-forms',
    name: 'MyCompanyAcceptanceForms',
    component: MyCompanyAcceptanceForms
  },
  {
    path: '/acceptance-forms/:id/new',
    name: 'MyCompanyAcceptanceFormsNew',
    component: MyCompanyAcceptanceFormsNew,
    props (route) {
      const props = { ...route.params }
      props.type = +props.type
      return props
    }
  },
  {
    path: '/acceptance-forms/:id/edit',
    name: 'MyCompanyAcceptanceFormsEdit',
    component: MyCompanyAcceptanceFormsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/acceptance-forms/list',
    name: 'MyCompanyAcceptanceFormsPreview',
    component: MyCompanyAcceptanceFormsPreview,
    props (route) {
      const props = { ...route.query }
      return props
    }
  },
  {
    path: '/invoices-list-report/pdf',
    name: 'MyCompanyGlobalInvoicesPreview',
    component: MyCompanyGlobalInvoicesPreview,
    props (route) {
      const props = { ...route.query }
      return props
    }
  },
  {
    path: '/acceptance-forms/:id/pdf',
    name: 'MyCompanyAcceptanceFormPreview',
    component: MyCompanyAcceptanceFormPreview,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/write-off-forms',
    name: 'MyCompanyWriteoffForms',
    component: MyCompanyWriteoffForms
  },
  {
    path: '/write-off-forms/new',
    name: 'MyCompanyWriteoffFormsNew',
    component: MyCompanyWriteoffFormsNew
  },
  {
    path: '/write-off-forms/:id/edit',
    name: 'MyCompanyWriteoffFormsEdit',
    component: MyCompanyWriteoffFormsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/write-off-forms/list',
    name: 'MyCompanyWriteoffFormsPreview',
    component: MyCompanyWriteoffFormsPreview,
    props (route) {
      const props = { ...route.query }
      return props
    }
  },
  {
    path: '/write-off-forms/:id/pdf',
    name: 'MyCompanyWriteoffFormPreview',
    component: MyCompanyWriteoffFormPreview,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/inventoryforms',
    name: 'MyCompanyInventoryForms',
    component: MyCompanyInventoryForms
  },
  {
    path: '/inventoryformsnew',
    name: 'MyCompanyInventoryFormsNew',
    component: MyCompanyInventoryFormsNew
  },
  {
    path: '/inventoryforms/:id/edit',
    name: 'MyCompanyInventoryFormsEdit',
    component: MyCompanyInventoryFormsEdit,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/inventory-forms/:id/pdf',
    name: 'MyCompanyInventoryFormPreview',
    component: MyCompanyInventoryFormPreview,
    props (route) {
      const props = { ...route.params }
      props.id = +props.id
      return props
    }
  },
  {
    path: '/current-stock',
    name: 'MyCompanyCurrentStock',
    component: MyCompanyCurrentStock
  },
  {
    path: '/current-stock-preview',
    name: 'MyCompanyCurrentStockPreview',
    component: MyCompanyCurrentStockPreview,
    props (route) {
      const props = { ...route.query }
      return props
    }
  },
  {
    path: '/article-card-preview',
    name: 'MyCompanyArticleCardPreview',
    component: MyCompanyArticleCardPreview,
    props (route) {
      const props = { ...route.query }
      return props
    }
  },
  {
    path: '/orders',
    component: SubPageContainer,
    redirect: {
      name: 'MyCompanyOpenTables'
    },
    children: [
      {
        path: 'ordersLatest',
        name: 'MyCompanyOrderHistory',
        component: MyCompanyOpenTables
      },
      {
        path: 'ordersType1Latest',
        name: 'MyCompanyType1OrderHistory',
        component: MyCompanyType1OpenTables
      }
    ]
  },
  {
    path: '/electronic_devices_list',
    name: 'ActiveCashRegisters',
    component: MyCompanyElectronicDevicesList
  },
  {
    path: '/material_diary_list',
    name: 'MyCompanyMaterialDiaryList',
    component: MyCompanyMaterialDiaryList
  },
  {
    path: '/reports',
    component: SubPageContainer,
    redirect: {
      name: 'MyCompanyReports'
    },
    children: [
      {
        path: 'users',
        name: 'MyCompanyReportsUsers',
        component: MyCompanyReportsUsers
      },
      {
        path: 'daily',
        name: 'MyCompanyReportsDaily',
        component: MyCompanyReportsDaily
      },
      {
        path: 'articles',
        name: 'MyCompanyReportsArticles',
        component: MyCompanyReportsArticles
      },
      {
        path: 'invoices-reports',
        name: 'MyCompanyReportsInvoices',
        component: MyCompanyReportsInvoices
      },
      /* {
        path: 'closedTables',
        name: 'MyCompanyReportsClosedTables',
        component: MyCompanyReportsClosedTables
      }, */
      {
        path: 'print',
        name: 'MyCompanyReportsPrint',
        component: MyCompanyReportsPrint,
        props: true
      },
      {
        path: '/daily-report-pdf-preview',
        name: 'MyCompanyReportsDailyPreview',
        component: MyCompanyReportsDailyPreview,
        props (route) {
          const props = { ...route.query }
          return props
        }
      },
    ]
  },
  {
    path: '/invoice-history',
    name: 'MyCompanyInvoiceHistory',
    component: MyCompanyInvoiceHistory
  },
  {
    path: '/invoice-preview/:id',
    name: 'MyCompanyInvoicePreview',
    component: MyCompanyInvoicePreview,
    props (route) {
      const props = { ...route.params }
      return props
    }
  },
  {
    path: '/material-diary-preview/',
    name: 'MyCompanyMaterialDiaryPreview',
    component: MyCompanyMaterialDiaryPreview,
  },
  {
    path: '/arhiv-preview/:id',
    name: 'MyCompanyArhivPreview',
    component: MyCompanyArhivPreview,
    props (route) {
      const props = { ...route.params }
      return props
    }
  },
  {
    path: '/control-tape',
    name: 'MyCompanyControlTape',
    component: MyCompanyControlTape
  },
  {
    path: '/control-tape-dl',
    name: 'MyCompanyControlTapeDownload',
    component: MyCompanyControlTapeDownload,
    props: true
  }
]
